import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { PAYMENT_METHOD } from '../constants';

export default class PaymentMethodSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: PAYMENT_METHOD.FIELD_NAME.INDIVIDUAL_ELECTRONIC_PAYMENT_IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: PAYMENT_METHOD.FIELD_NAME.INDIVIDUAL_ELECTRONIC_PAYMENT_NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
    ]);
  }
}
